import script from "./management.doctor.modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./management.doctor.modal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__